export const maskEmail = (email: string) => {
  const [localPart, domainPart] = email.split('@');

  const numVisibleLocal = Math.ceil(localPart.length / 2);
  const numVisibleDomain = Math.ceil(domainPart.length / 2);
  const domain = domainPart.split('.');
  const domainLength = domain.length;
  const visibleLocalPart = localPart.slice(0, numVisibleLocal);
  const visibleDomainPart = domainPart.slice(
    0,
    numVisibleDomain - domainLength
  );
  const maskedLocalPart = `${visibleLocalPart}***`;
  const maskedDomainPart = `${visibleDomainPart}***`;

  return `${maskedLocalPart}@${maskedDomainPart}.${domain[domainLength - 1]}`;
};

export const maskPhone = (phone: string) => {
  const lastFourDigits = phone.slice(-4);
  return `***${lastFourDigits}`;
};
